_ = require 'underscore'
ApiPromise = require 'app/scripts/network/api-promise'
Dates = require 'app/scripts/lib/dates'
TrelloModel = require 'app/scripts/models/internal/trello-model'

DEBOUNCE_INTERVAL = 500 #ms

class CustomFieldItem extends TrelloModel
  typeName: 'CustomFieldItem'
  url: ->
    idCard = @get('idModel')
    idCustomField = @get('idCustomField')
    "/1/card/#{ idCard }/customField/#{ idCustomField }/item"

  @colors: ['green', 'yellow', 'orange', 'red', 'purple',
            'blue', 'sky', 'lime', 'pink', 'black', 'none']

  getCard: ->
    @modelCache.get('Card', @get('idModel'))

  getCustomField: ->
    @modelCache.get('CustomField', @get('idCustomField'))

  clearValue: ->
    @setValue(null)

  setValue: (newValue) ->
    # default key for payload
    valueKey = 'value'
    fieldType = @getType()

    if fieldType == 'list'
      valueKey = 'idValue'

    @update {
      "#{valueKey}": newValue
    }, { debounceSaveInterval: DEBOUNCE_INTERVAL }

  sync: (method, model, options) ->
    # we want to ensure that we always use PUT
    # so that when creating a custom field item it is treated more
    # as an update to the card
    # The expectation is this is just used for creation, for updates and deletes
    # use the setValue and clearValue methods instead
    options.type = 'PUT'
    super

  getType: ->
    @getCustomField()?.get('type')

  getColor: ->
    if @getType() == 'list'
      idValue = @get('idValue')
      @getCustomField().getOption(idValue)?.get('color') || 'none'
    else
      @get('color') || 'none'

  getParsedValue: ->
    value = @get('value')
    idValue = @get('idValue')
    type = @getType()
    switch type
      when 'checkbox' then value?.checked == 'true'
      when 'date' then new Date(value.date)
      when 'list' then @getCustomField().getOption(idValue)?.get('value').text || ''
      when 'number' then parseFloat(value.number)
      when 'text' then value?.text || ''

  getFrontBadgeText: ->
    parsedVal = @getParsedValue()
    type = @getType()
    switch type
      when 'checkbox' then @getCustomField().get('name')
      when 'date' then Dates.toDateString(parsedVal)
      when 'number' then parsedVal.toLocaleString()
      else parsedVal

  # For Custom Fields we are interested in searching the following:
  # Have a checked checkbox field whose name matches the search terms
  # Have a text field whose value matches the search terms
  # Have a list field selection whose value matches the search terms
  # Have a numeric field whose value matches the search value
  getFilterableWords: (fxGetWords) ->
    if @isEmpty()
      return []

    parsedVal = @getParsedValue()
    type = @getType()
    if type == 'number'
      # this is a bit weird, but we want the filter to work on both
      # the formatted number for example 0.01 as well as the raw number .01
      if parsedVal < 1 && parsedVal > -1
        return [@get('value').number, @getFrontBadgeText()]
      else
        # we want to avoid the formatted ones that aren't just leading 0
        # this is because things like commas are tricky to handle with the filter
        return [@get('value').number]

    if type != 'date' && parsedVal
      return fxGetWords(@getFrontBadgeText())

    return []

  isEmpty: ->
    if @getType() == 'list'
      !@get('idValue')?
    else
      !@get('value')?

  showFrontBadge: ->
    customField = @getCustomField()
    if !customField?.visible()
      return false
    if !customField.get('display')?.cardFront
      return false
    if @isEmpty()
      return false
    if customField.get('type') == 'checkbox' && @get('value')?.checked != 'true'
      return false
    if customField.isList() && !customField.getOption(@get('idValue'))
      return false
    return true

module.exports = CustomFieldItem
